var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTechoFv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2524_10360)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.258423,
    y: 0.719116,
    width: 24.9438,
    height: 24.9438,
    rx: 12.4719,
    fill: "#828282"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.7145 10.1532C9.82062 9.96498 10.0199 9.84857 10.236 9.84857H17.5078C17.7222 9.84857 17.9202 9.9632 18.0269 10.1491L21.1068 15.512C21.2132 15.6973 21.2128 15.9252 21.1057 16.1101C20.9987 16.295 20.8013 16.4088 20.5876 16.4088H13.4786C13.2691 16.4088 13.0748 16.2992 12.9664 16.1199L9.72366 10.757C9.61188 10.5721 9.60838 10.3413 9.7145 10.1532ZM11.2975 11.0459L13.8162 15.2115H19.5535L17.1613 11.0459H11.2975Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.995778 17.8661C0.714198 17.6928 0.626403 17.324 0.799683 17.0425L6.1587 8.33406C6.33198 8.05248 6.70072 7.96469 6.9823 8.13797C7.26388 8.31125 7.35167 8.67999 7.17839 8.96157L1.81938 17.67C1.6461 17.9515 1.27736 18.0393 0.995778 17.8661Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2147 17.985C11.9299 18.153 11.5629 18.0583 11.3949 17.7735L6.26603 9.07669C6.09808 8.7919 6.19279 8.42488 6.47758 8.25693C6.76237 8.08897 7.12939 8.18369 7.29735 8.46848L12.4262 17.1653C12.5942 17.45 12.4995 17.8171 12.2147 17.985Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.1877 17.985C23.9029 18.153 23.5359 18.0583 23.368 17.7735L18.2391 9.07669C18.0711 8.7919 18.1658 8.42488 18.4506 8.25693C18.7354 8.08897 19.1024 8.18369 19.2704 8.46848L24.3993 17.1653C24.5672 17.45 24.4725 17.8171 24.1877 17.985Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4832 17.5811C11.4832 17.2505 11.7512 16.9825 12.0818 16.9825H23.8553C24.1859 16.9825 24.4539 17.2505 24.4539 17.5811C24.4539 17.9118 24.1859 18.1798 23.8553 18.1798H12.0818C11.7512 18.1798 11.4832 17.9118 11.4832 17.5811Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.24493 8.60134C6.24493 8.27071 6.51296 8.00269 6.84359 8.00269L18.6171 8.00269C18.9477 8.00269 19.2157 8.27071 19.2157 8.60134C19.2157 8.93196 18.9477 9.19999 18.6171 9.19999L6.84359 9.19999C6.51296 9.19999 6.24493 8.93196 6.24493 8.60134Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9843 12.2431C10.9843 11.9124 11.2523 11.6444 11.5829 11.6444H18.3676C18.6983 11.6444 18.9663 11.9124 18.9663 12.2431C18.9663 12.5737 18.6983 12.8417 18.3676 12.8417H11.5829C11.2523 12.8417 10.9843 12.5737 10.9843 12.2431Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.982 14.0142C11.982 13.6836 12.2501 13.4156 12.5807 13.4156H19.3654C19.696 13.4156 19.964 13.6836 19.964 14.0142C19.964 14.3449 19.696 14.6129 19.3654 14.6129H12.5807C12.2501 14.6129 11.982 14.3449 11.982 14.0142Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2883 16.1942C16.0071 16.3682 15.6382 16.2814 15.4641 16.0003L12.2213 10.7622C12.0473 10.4811 12.1341 10.1122 12.4152 9.93812C12.6963 9.76409 13.0653 9.85089 13.2393 10.132L16.4821 15.3701C16.6562 15.6512 16.5694 16.0202 16.2883 16.1942Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.649 16.2404C18.3649 16.4095 17.9975 16.3163 17.8284 16.0322L14.7103 10.7941C14.5412 10.51 14.6344 10.1426 14.9185 9.97347C15.2026 9.80436 15.57 9.89757 15.7391 10.1817L18.8572 15.4198C19.0263 15.7039 18.9331 16.0713 18.649 16.2404Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2524_10360"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.258423,
    y: 0.719116,
    width: 24.9438,
    height: 24.9438,
    rx: 12.4719,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechoFv);
export default __webpack_public_path__ + "static/media/techo-fv.6d5c57c3506da250c4536da7195e7433.svg";
export { ForwardRef as ReactComponent };